<template>
  <v-snackbar :timeout="1500"
              :color="type"
              top
              right
              v-model="show">
    {{ message }}

    <template v-slot:action="{ attrs }">
      <v-btn
        text
        v-bind="attrs"
        @click="show = false"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "InfoSnackbar",
  data() {
    return {
      show: false
    }
  },

  props: ['type', 'message'],

  methods:{
    openSnackbar(){
      this.show = true;
    }
  }
}
</script>

<style scoped>

</style>
